module.exports = __webpack_public_path__ + "img/medibank.f2cd5965.png";